export const SHOW_OTP = 'SHOW_OTP';
export const SET_PASSWORD_OTP_REQUEST_ID = 'SET_PASSWORD_OTP_REQUEST_ID';
export const FP_OTP_ERROR = 'FP_OTP_ERROR';
export const PASSWORD_CHANGE_BY = 'PASSWORD_CHANGE_BY';
export const SEND_PASSWORD_OTP_REQUEST = 'SEND_PASSWORD_OTP_REQUEST';
export const SET_PASSWORD_TOKEN = 'SET_PASSWORD_TOKEN';
export const VERIFY_PASSWORD_OTP = 'VERIFY_PASSWORD_OTP';
export const GENERATE_PASSWORD_OTP = 'GENERATE_PASSWORD_OTP';
